module.exports = __webpack_public_path__ + "img/section1.d30ebbb.svg";